import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import { multipleTipoMercado } from '../../utils/tipoMercado'

import { Cenario } from '../../components'
import * as cenarioActionCreators from '../../redux/modules/cenario'
import * as flashMessageAcionCreators from '../../redux/modules/flashMessage'
import * as sortActionCreators from '../../redux/modules/sort'
import * as filterActionCreators from '../../redux/modules/filter'

import { filterMap, sortMap } from '../../utils/mapTools'
import { arrayToCSV } from '../../utils/arrayToCSV'

class CenarioContainer extends Component {

  static propTypes = {
    destroyCenario: PropTypes.func,
    error: PropTypes.array,
    fetchMultipleCenario: PropTypes.func,
    filterText: PropTypes.string,
    hideFlashMessage: PropTypes.func,
    history: PropTypes.object,
    instalacao: PropTypes.object.isRequired,
    isLoading: PropTypes.bool,
    multipleCenario: PropTypes.object,
    showErrorFlashMessage: PropTypes.func,
    showSuccessfulFlashMessage: PropTypes.func,
    sortColumn: PropTypes.string,
    sortDirection: PropTypes.string,
    updateFilter: PropTypes.func.isRequired,
    updateSort: PropTypes.func.isRequired,
  }

  async componentDidMount () {
    const { instalacao } = this.props
    await Promise.all([
      this.props.fetchMultipleCenario(instalacao.id),
    ])
  }

  handleRedirectToNew = (instalacaoId) => {
    this.props.history.push(`/instalacoes/${instalacaoId}/cenarios/new`)
  }

  handleEditResource = (instalacaoId, id) => {
    this.props.history.push(`/instalacoes/${instalacaoId}/cenarios/${id}/edit`)
  }

  handleDeleteResource = async (id) => {
    await this.props.destroyCenario(id)
      ? this.props.showSuccessfulFlashMessage('', 'destroy')
      : this.props.showErrorFlashMessage('', 'destroy', this.props.error)
  }

  handleSort = column => () => this.props.updateSort('cenario', column)

  handleSorted = column => this.props.sortColumn === column
    ? this.props.sortDirection
    : null

  handleFilter = (name, value) => this.props.updateFilter('cenario', name, value)

  handleExportToCSV = () => {
    arrayToCSV(
      this.props.multipleCenario.toList().toJSON(),
      'cenario',
      [
        'id'
      ]
    )
  }

  componentWillUnmount () {
    this.props.hideFlashMessage()
  }

  render () {
    return (
      <Cenario
        instalacao={this.props.instalacao}
        multipleCenario={this.props.multipleCenario}
        multipleTipoMercado={multipleTipoMercado}
        onRedirectToNew={() => this.handleRedirectToNew(this.props.instalacao.id)}
        onEditResource={this.handleEditResource}
        onDeleteResource={this.handleDeleteResource}
        handleSort={this.handleSort}
        handleSorted={this.handleSorted}
        handleFilter={this.handleFilter}
        filterText={this.props.filterText}
        onExportToCSV={this.handleExportToCSV}
        isLoading={this.props.isLoading}
      />
    )
  }
}

function mapStateToProps ({cenario, status, sort, filter}, {instalacao}) {
  const sortColumn = sort.getIn(['cenario', 'sortColumn']) || 'starts_at'
  const sortDirection = sort.getIn(['cenario', 'sortDirection']) || 'ascending'
  const filterText = filter.getIn(['cenario', 'filterText']) || ''

  let map = filterMap(cenario, ['starts_at'], filterText)
  map = sortMap(map, sortColumn, sortDirection)

  return {
    multipleCenario: map.filter(t => t.get('instalacao_id') === instalacao.id),
    error: status.getIn(['cenario', 'error']),
    isLoading: status.getIn(['cenario', 'isLoading']),
    sortColumn,
    sortDirection,
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    ...flashMessageAcionCreators,
    ...cenarioActionCreators,
    ...sortActionCreators,
    ...filterActionCreators,
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CenarioContainer))
